import { AuthCookieService } from '@utils/AuthCookieService'

export async function getFileUrl(url: string): Promise<string | undefined> {
  try {
    const authInfo = await AuthCookieService.getAuthInfo()
    const token = authInfo?.accessToken
    const response = await fetch(url, { headers: { Authorization: `Bearer ${token}` }, method: 'GET' })
    const json = await response.json()
    return json.url
  } catch (error) {}

  return undefined
}
